module.exports = __webpack_public_path__ + "static/media/group-tablet.8fe82ed9.svg";